import { __decorate } from "tslib";
import { LitElement, html, css } from "lit";
import { customElement, state } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import { when } from "lit/directives/when.js";
let SeTitleElement = class SeTitleElement extends LitElement {
    myClick(e) {
        alert(e.type);
    }
    firstUpdated() { }
    hide() { }
    showTitle(title, description, maxWidth) {
        this._title = title;
        this._description = description;
        this._maxWidth = maxWidth !== null && maxWidth !== void 0 ? maxWidth : 250;
    }
    render() {
        const titleStyle = {
            "text-decoration": this._description ? "underline" : "none",
            "max-width": this._maxWidth + "px",
        };
        if (typeof this._title === "string") {
            return html `
                <div style="${styleMap(titleStyle)}">${this._title}</div>
                ${when(this._description, () => html `<div style="margin:5px 0 0 0; ${styleMap({ "max-width": this._maxWidth + "px" })}">${this._description}</div>`)}
            `;
        }
        else {
            return this._title;
        }
    }
};
SeTitleElement.styles = css `
        :host[hidden] {
            display: hidden;
        }
        :host {
            display: block;
            background-color: DimGray;
            border-radius: 3px 3px;
            color: white;
            font: var(--font-small);
            position: absolute;
            z-index: 2000;
            padding: 5px 10px 5px 10px;
            left: -1000px;
            top: -1000px;
            word-wrap: break-word;
        }
    `;
__decorate([
    state()
], SeTitleElement.prototype, "_title", void 0);
SeTitleElement = __decorate([
    customElement("se-title")
], SeTitleElement);
export { SeTitleElement };
//# sourceMappingURL=title.element.js.map